export class General_Config {
    public static api_url: string = 'https://www.angelecom.com:3001/';
    public static active_page: string = 'Login';
    public static session_key: string = 'angelecom_client_';
    public static image_base: string = 'https://www.angelecom.com/server/';
}